import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QueryManagerService } from 'projects/box-lib/src/lib/services/queryManagerService';
import { OperationsPaginatedCollectionSegment } from '../../models/generated/graphql';
import { AuthService } from '../../services/auth-service.service';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

export interface OperationsSimlilarDocument {
  investisseur: string;
  typeOperation: string;
  produit: string;
  montant: number;
}

@Component({
    selector: 'lib-operation-document-update-dialog',
    templateUrl: './operation-document-update-dialog.component.html',
    styleUrls: ['./operation-document-update-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OperationDocumentUpdateDialogComponent {
  operations: OperationsPaginatedCollectionSegment[] = [];
  documentId: number;
  numberOfOperations: number = 0;
  dataSource: MatTableDataSource<OperationsPaginatedCollectionSegment> =
    new MatTableDataSource<OperationsPaginatedCollectionSegment>([]);

  displayedColumns: string[] = ['investisseur', 'operationType', 'produit', 'montant'];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { operations?: OperationsPaginatedCollectionSegment[] },
    private dialogRef: MatDialogRef<OperationDocumentUpdateDialogComponent>
  ) {
    this.operations = data.operations || [];
    this.dataSource.data = this.operations;
  }
  async updateDocumentForOperations() {}

  async ngOnInit() {
    this.operations = this.data.operations || [];
    this.numberOfOperations = this.operations.length;
  }

  cancel() {
    this.dialogRef.close([]);
  }

  validate() {
    this.dialogRef.close(this.data.operations);
  }
}
